
import Hi from '../../assets/hi-animation.json';
import Star1 from '../../assets/star-animation-1.json';
import Star2 from '../../assets/star-animation-2.json';
import Star3 from '../../assets/star-animation-3.json';
import Star4 from '../../assets/star-animation-4.json';
import Star5 from '../../assets/star-animation-5.json';

export const hiOptions = {
  animationData: Hi,
  loop: false,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export const starOptions = [
  { animationData: Star1, loop: true, autoplay: true },
  { animationData: Star2, loop: true, autoplay: true },
  { animationData: Star3, loop: true, autoplay: true },
  { animationData: Star4, loop: true, autoplay: true },
  { animationData: Star5, loop: true, autoplay: true }
];
